<template>
  <div>
    <div class="bg">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3.75rem;
          font-weight: bold;
        "
        class="container dis-top"
      >
        <div
          style="
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <img
            src="../../assets/imgs/icon-dis.png"
            style="
              width: 4.0625rem;
              height: 4.0625rem;
              position: absolute;
              left: -30px;
              z-index: 1;
              top: 1rem;
            "
            class="dis-top-img"
          />
          <span style="z-index: 10">Discussion</span>
        </div>
      </div>
      <div class="main container">
        <img
          :src="
            disleftlight == 0
              ? require('../../assets/imgs/banner-left.png')
              : require('../../assets/imgs/banner-left-light.png')
          "
          class="change-box dis-l-btn"
          style="left: -30px"
          @click="predis"
          @mouseenter="disleftbtn(1)"
          @mouseleave="disleftbtn(0)"
          v-show="disActive != 0"
        />
        <div
          style="width: 100%; overflow: hidden"
          class="box"
          @touchstart="touchStart"
          @touchend="touchEnd"
        >
          <!-- <div class="wrapper" ref="wrapper"> -->
          <div
            class="content transition-normal"
            style="display: flex; flex-wrap: nowrap; width: 100%"
            :style="{
              marginLeft:
                'calc(-100*' + disActive + '% - 10*' + disActive + 'rem)',
            }"
          >
            <!-- q1 -->
            <div
              style="display: flex; min-width: 100%; margin-right: 10rem"
              class="fadeIn animated box-border"
              v-for="(item, index) in data"
              :key="index"
            >
              <!-- <div style="display: flex;" class="fadeIn animated box-border" v-for="(item, index) in data.circles" :key="index"> -->

              <div class="box-left">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    border-bottom: 1px solid #dbdbdb;
                    padding: 1rem 0rem;
                    min-height: fit-content;
                  "
                  v-for="(disitem, index1) in dislist[index]"
                  :key="index1"
                >
                  <div style="display: flex; align-items: center">
                    <div style="">
                      <img
                        :src="disitem.user.avatar"
                        style="
                          width: 2.5rem;
                          height: 2.5rem;
                          border-radius: 50%;
                        "
                      />
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        margin-left: 0.5rem;
                      "
                    >
                      <div style="font-weight: bold; font-size: 1rem">
                        {{ disitem.user.username }}
                      </div>
                      <div style="font-size: 0.75rem; color: #a8a8a8">
                        {{ disitem.createdAt | format }}
                      </div>
                    </div>
                  </div>
                  <div
                    style="font-size: 0.75rem; margin-top: 1rem; color: #717171"
                  >
                    {{ disitem.content }}
                  </div>
                  <div style="display: flex; margin-top: 1rem; flex-wrap: wrap">
                    <div
                      :style="{ backgroundImage: 'url(' + img + ')' }"
                      class="dis-img"
                      v-for="(img, index4) in disitem.images"
                      :key="index4"
                      style="
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-position: top center;
                        cursor: pointer;
                      "
                      @click="largeimg(disitem.images, index4)"
                    ></div>
                  </div>
                  <div
                    style="display: flex; align-items: center; margin-top: 1rem"
                  >
                    <img
                      src="../../assets/imgs/icon-pin.svg"
                      alt=""
                      class="l-icon"
                    />
                    <span class="l-text">{{ disitem.commentCount }}</span>
                    <img
                      src="../../assets/imgs/icon-zan.svg"
                      alt=""
                      class="l-icon"
                    />
                    <span class="l-text">{{ disitem.likeCount }}</span>
                  </div>
                </div>
              </div>

              <div
                class="box-right"
                @click="tocircletopic(item.id)"
                style="cursor: pointer"
              >
                <img
                  :src="require('../../assets/imgs/dis-r-' + item.id + '.png')"
                  style=""
                  class="box-r-bg"
                />
                <div
                  style="
                    position: absolute;
                    right: -1rem;
                    top: 3rem;
                    width: 6rem;
                    height: 2rem;
                    background-color: #fedf34;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1rem;
                    font-weight: bold;
                    rotate: 355deg;
                    z-index: 10;
                  "
                >
                  <img
                    src="../../assets/imgs/dis-right-icon.png"
                    alt=""
                    style="width: 0.85rem; height: 1rem; margin-right: 0.5rem"
                  />{{ item.followCount }}
                </div>
                <div
                  style="
                    padding: 2rem;
                    display: flex;
                    flex-direction: column;
                    z-index: 10;
                    position: absolute;
                  "
                >
                  <div style="">
                    <img
                      :src="item.avatar"
                      alt=""
                      style="width: 4rem; height: 4rem; border-radius: 50%"
                    />
                  </div>
                  <div style="height: 20rem">
                    <div class="r-title">
                      {{ item.title }}
                    </div>
                    <div class="r-text">
                      {{ item.profile }}
                    </div>
                  </div>
                  <div style="flex: 1">
                    <img
                      :src="avatar"
                      class="r-img"
                      v-for="(avatar, avatarindex) in item.avatars.slice(0, 6)"
                      :key="avatarindex"
                    />
                    <img src="../../assets/imgs/dis-r-more.png" class="r-img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <img
          :src="
            disrightlight == 0
              ? require('../../assets/imgs/banner-right.png')
              : require('../../assets/imgs/banner-right-light.png')
          "
          class="change-box dis-r-btn"
          style="right: -30px"
          @click="nextdis"
          @mouseenter="disrightbtn(1)"
          @mouseleave="disrightbtn(0)"
          v-show="disActive != 4"
        />
      </div>

      <div style="margin: 1rem 0; width: 100%">
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <div
            style="
              width: 0.5rem;
              height: 0.5rem;
              border-radius: 50%;
              margin: 0 0.3rem;
            "
            v-for="i in data.length"
            :key="i"
            :style="{
              backgroundColor: i - 1 == disActive ? '#31ffda' : '#a4a4a4',
            }"
          ></div>
        </div>
      </div>

      <!-- expert -->
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 5rem;
          flex-direction: column;
        "
        class="container"
      >
        <div style="" class="author-title">
          <img
            src="../../assets/imgs/icon-dis.png"
            style=""
            class="author-title-img"
          /><span style="z-index: 4">Subject Matter Experts</span>
        </div>
        <div style="" class="author-title-dec">
          SME from around the world provide free appointment and consultation
        </div>
        <div style="" class="author-wrapper">
          <!-- <img  :src="active==0?require('../../assets/imgs/banner-left.png'):require('../../assets/imgs/banner-left-light.png')" alt="" class="change-item" style="left: -5rem;" @click="preAuthor"> -->
          <div
            class="change-item change-item-left"
            @click="preAuthor"
            v-show="exceptActive != 0"
          ></div>
          <div class="author-box">
            <div
              class="row"
              style="flex-wrap: nowrap; transition: all 0.2s linear"
              :style="{ marginLeft: exceptoffest + 'rem' }"
            >
              <div
                class="mb-30 author-item"
                style=""
                v-for="(item, index3) in exceptlist"
                :key="index3"
              >
                <div
                  class="author-group transition-normal"
                  :class="{ 'hover-up-2': !isMobile }"
                >
                  <!-- <img :src="item.avatar" class="author-group-img"> -->
                  <div
                    :style="{ backgroundImage: 'url(' + item.avatar + ')' }"
                    style="
                      background-size: cover;
                      background-repeat: no-repeat;
                      background-position: top center;
                    "
                    class="author-group-img"
                    @click="authorboxshow(1, item)"
                  ></div>
                  <div
                    class="author-group-dark"
                    style="cursor: pointer"
                    @click="authorboxshow(1, item)"
                  >
                    <img
                      src="../../assets/imgs/author-group-hover.png"
                      alt=""
                      style="width: 2.5rem; height: 2.5rem"
                    />
                  </div>
                  <span
                    class="author-group-text"
                    @click="authorboxshow(1, item)"
                    style="cursor: pointer"
                    >{{ item.realName }}</span
                  >

                  <div
                    class="author-group-btn"
                    @click="changefollow(item)"
                    :style="{
                      backgroundColor: item.follow ? '#D4F9F3' : '#31FFDA',
                    }"
                    style="cursor: pointer"
                  >
                    {{ item.follow ? "unfollow" : "follow +" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <img :src="active==3?require('../../assets/imgs/banner-right.png'):require('../../assets/imgs/banner-right-light.png')" alt="" class="change-item" style="right: -5rem;" @click="nextAuthor"> -->
          <div
            class="change-item change-item-right"
            @click="nextAuthor"
            v-show="exceptActive != exceptlist.length - (isMobile ? 1 : 4)"
          ></div>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2.25rem;
            padding: 0.5rem 1rem;
            margin-top: 1.5rem;
            font-size: 0.9rem;
            font-weight: bold;
            color: #181818;
            cursor: pointer;
            margin-bottom: 1.5rem;
          "
          class="btn-cyan-liner hover-shadow"
          @click="toexpert"
        >
          Make an Appoinment
          <img
            src="../../assets/imgs/arrow-rigth.png"
            style="width: 1.5rem; height: 1.5rem; margin-left: 0.3rem"
          />
        </div>
      </div>
    </div>

    <div
      style="
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
      "
      v-if="authorbox == 1"
    >
      <div
        style="
          background-color: rgba(0, 0, 0, 0.9);
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
        "
      ></div>
      <div
        style="display: flex; z-index: 10"
        class="fadeInDown animated author-dialog"
      >
        <div style="" class="author-dialog-left">
          <!-- <img :src="exceptitem.avatar" style="width: 100%;height: 13.5rem;"> -->
          <div
            :style="{ backgroundImage: 'url(' + exceptitem.avatar + ')' }"
            style=""
            class="author-dialog-img"
          ></div>
          <div class="author-dialog-left-name">
            <div
              style="
                font-size: 1.5rem;
                color: #000;
                font-weight: bold;
                margin-top: 1rem;
              "
            >
              {{ exceptitem.realName }}
            </div>
            <!-- <div style="display: flex;align-items: center;justify-content: center;width: 8rem;height: 2.5rem;background-color: #000;color: #fff;margin-top: 2rem;
								border-radius: 2rem;">Follow +</div> -->
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 8rem;
                height: 2.5rem;
                margin-top: 2rem;
                border-radius: 2rem;
                cursor: pointer;
              "
              :style="{
                backgroundColor: exceptitem.follow ? '#fff' : '#000',
                color: exceptitem.follow ? '#000' : '#fff',
              }"
              @click="changefollow(exceptitem)"
              v-text="exceptitem.follow ? 'UnFollow' : 'Follow +'"
            ></div>
          </div>
        </div>
        <div style="" class="author-dialog-right">
          <div
            style="display: flex; flex-direction: column; overflow: scroll"
            class="exceptbox"
          >
            <div style="color: #000; font-size: 1.5rem; font-weight: bold">
              <span style="border-bottom: 0.2rem solid #31ffda"
                >Personal profile</span
              >
            </div>
            <div
              style="
                color: #707070;
                font-weight: 400;
                margin-top: 1rem;
                font-size: 0.7rem;
                user-select: none;
              "
            >
              {{ exceptitem.profile }}
            </div>

            <div
              style="
                color: #000;
                font-size: 1.5rem;
                font-weight: bold;
                margin-top: 1rem;
              "
              v-if="exceptitem.honour.length > 0"
            >
              <span style="border-bottom: 0.2rem solid #31ffda"
                >Industry honor</span
              >
            </div>
            <div style="display: flex; margin-top: 1rem; flex-wrap: wrap">
              <img
                :src="img"
                style="
                  width: 6rem;
                  height: 7.2rem;
                  margin-right: 1rem;
                  margin-bottom: 0.2rem;
                "
                v-for="(img, index4) in exceptitem.honour"
              />
            </div>
          </div>
          <div
            style="position: absolute; right: 1rem; top: 1rem; cursor: pointer"
          >
            <img
              src="../../assets/imgs/box-close.png"
              style="width: 2rem; height: 2rem"
              @click="authorboxshow(0, {})"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { WOW } from "wowjs";
import { baseUrl } from "../../assets/js/public.js";
import bScorll from "better-scroll";
export default {
  data() {
    return {
      isMobile: localStorage.getItem("isMobile"),
      // loading:false
      active: 0,
      // bscorll:null,
      disActive: 0,
      disleftlight: 0,
      disrightlight: 0,

      touchStartX: 0,
      touchStartY: 0,
      delta: 50,

      authorbox: 0,
      data: [],
      dislist: [],
      exceptlist: [],
      exceptitem: {},
      exceptoffest: 0,
      isMobile: false,
      disbtnshow: false,
      exceptbtnshow: false,
      exceptActive: 0,
      //   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
    };
  },
  components: {},
  filters: {},
  methods: {
    largeimg(imgs, index) {
      this.$bus.$emit("largeimg", { show: true, imgs: imgs, index: index });
    },
    touchStart(e) {
      console.log("触摸开始");
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    },
    touchEnd(e) {
      console.log("触摸结束");
      let deltaX = e.changedTouches[0].clientX - this.touchStartX;
      let deltaY = e.changedTouches[0].clientY - this.touchStartY;
      console.info("sx", this.touchStartX);
      console.info("ex", deltaX);
      // X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
      if (
        Math.abs(deltaX) > this.delta &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        if (deltaX >= 0) {
          console.log("右滑");
          this.predis();
        } else {
          console.log("左滑");
          this.nextdis();
        }
        // Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
      } else if (
        Math.abs(deltaY) > this.delta &&
        Math.abs(deltaX) < Math.abs(deltaY)
      ) {
        if (deltaY < 0) {
          console.log("上滑");
        } else {
          console.log("下滑");
        }
        // 两轴位移都特别小，可以判断是点击
      } else if (Math.abs(deltaY) < 25 && Math.abs(deltaX) < 25) {
        console.log("点击");
      } else {
        console.log("可能是误触");
      }
    },
    tocircletopic(id) {
      this.$router.push({ name: "circletopic", query: { id: id } });
    },
    changefollow(item) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        let params = {
          expertId: item.id,
        };
        this.request({
          url: "/gci/user/expert/follow",
          method: "post",
          data: params,
        })
          .then((res) => {
            if (this.exceptitem) {
              this.exceptitem.follow = !this.exceptitem.follow;
            }
            this.getexceptdata();
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    getData() {
      this.request({
        method: "get",
        url: "/gci/circle/list",
      })
        .then((res) => {
          this.data = res.data.items;
          console.info("circle:", this.data);
          this.getdisdata();
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getdisdata() {
      for (let i in this.data) {
        this.request({
          method: "get",
          url: "/gci/circleTopic/list?circleId=" + this.data[i].id,
        })
          .then((res) => {
            this.dislist.push(res.data.items);
            this.$bus.$emit("loading", false);
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
      console.info("dislist", this.dislist);
    },
    getexceptdata() {
      this.request({
        method: "get",
        url: "/gci/user/expert/list",
      })
        .then((res) => {
          this.exceptlist = res.data.items;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    touchstart(ev) {
      console.log(ev);
    },
    touchend(ev) {},
    predis() {
      if (this.disActive > 0) {
        this.disActive--;
      }
    },
    nextdis() {
      if (this.disActive < 4) {
        this.disActive++;
      }
    },
    disleftbtn(i) {
      this.disleftlight = i;
    },
    disrightbtn(i) {
      this.disrightlight = i;
    },
    preAuthor() {
      if (this.exceptoffest < 0) {
        this.exceptActive--;
        this.exceptoffest += 17.9;
      }
    },
    nextAuthor() {
      let offsetcount;
      this.isMobile ? (offsetcount = 1) : (offsetcount = 4);
      if (this.exceptoffest > -(18 * (this.exceptlist.length - offsetcount))) {
        this.exceptActive++;
        this.exceptoffest -= 17.9;
      }
    },
    authorboxshow(i, item) {
      // this.authorbox = i
      // this.exceptitem = item

      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.authorbox = i;
        this.exceptitem = item;
      }
    },
    toexpert() {
      this.$router.push({ name: "expert" });
    },
  },
  mounted() {
    localStorage.getItem("isMobile") == "null"
      ? (this.isMobile = false)
      : (this.isMobile = true);
    if (localStorage.getItem("token")) {
      this.islogin = true;
      let userinfo = JSON.parse(localStorage.getItem("user"));
      if (userinfo.vip.id != 1) {
        this.isuserlevel = true;
      }
    }
    this.getData();
    this.getexceptdata();
  },
};
</script>

<style scoped lang="scss">
// .wrapper{
// 	.content{
// 		display: flex;
// 	}
// }
.bg {
  background: linear-gradient(161deg, #ffffff 0%, #f6fefe 62%, #f0fdfd 100%);
  padding-bottom: 2vw;
}
.main {
  display: flex;
  align-items: center;
  /* margin: 30px; */
  margin-top: 30px;
  position: relative;
}
.box {
  background: #ffffff;
  box-shadow: 0px 20px 40px 1px rgba(0, 0, 0, 0.04);
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  border: 1px solid #ededed;
  max-height: 37.5rem;
  padding: 3.75rem 4.7rem 2.5rem;
  display: flex;
  flex-wrap: nowrap;
}
.change-box {
  height: 80px;
  width: 80px;
  position: absolute;
  cursor: pointer;
}
.box-left {
  display: flex;
  flex-direction: column;
  max-height: 30rem;
  min-height: 30rem;
  overflow: scroll;
  width: 60%;
  /* -webkit-scrollbar {display:none} */
}
.box-left::-webkit-scrollbar {
  display: none;
}
.dis-img {
  width: 9rem;
  height: 9rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.l-icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
}
.l-text {
  font-weight: bold;
  font-size: 0.75rem;
  margin-right: 1rem;
}

.box-right {
  width: 35%;
  margin-left: 5%;
  position: relative;
}
.r-title {
  font-size: 1.875rem;
  font-weight: bold;
  margin-top: 1rem;
}
.r-text {
  color: #2c2c2c;
  font-size: 1rem;
  margin-top: 1rem;
}
.r-img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  margin-right: 0.2rem;
}
.change-item {
  height: 80px;
  width: 80px;
  cursor: pointer;
  // margin: 0 1rem;
  position: absolute;
  top: 6rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 10;
}
.author-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 1rem;
  margin: 0 0.2rem;
  position: relative;
  // overflow:scroll
  overflow: hidden;
}

.author-group-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #D4F9F3;
  border-radius: 2.25rem;
  // width: 6rem;
  // height: 2rem;
  padding: 0.4rem 0.8rem;
  margin-top: 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #181818;
}
.author-group-text {
  font-size: 1.2rem;
  font-weight: 500;
  margin-top: 1rem;
}
.author-group-dark {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  // display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.47);
  width: 16rem;
  height: 19rem;
}
.author-group:hover {
  background-color: #fff;
  box-shadow: 0px 0.625rem 1rem 1px rgba(0, 0, 0, 0.08);

  .author-group-dark {
    display: flex;
  }

  .author-group-text {
    color: #00e8be;
  }

  // .author-group-btn{
  // 	background: #31FFDA;
  // }
}
.author-box {
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: hidden;
}
.author-box::-webkit-scrollbar {
  display: none;
}

.author-group-img {
  width: 16rem;
  height: 19rem;
}
.exceptbox::-webkit-scrollbar {
  display: none;
}
.change-item-left {
  left: -5rem;
  background-image: url("../../assets/imgs/banner-left.png");
}
.change-item-left:hover {
  background-image: url("../../assets/imgs/banner-left-light.png");
}
.change-item-right {
  right: -5rem;
  background-image: url("../../assets/imgs/banner-right.png");
}
.change-item-right:hover {
  background-image: url("../../assets/imgs/banner-right-light.png");
}
.box-r-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.author-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.75rem;
  font-weight: bold;

  .author-title-img {
    width: 4.0625rem;
    height: 4.0625rem;
    position: absolute;
    left: -30px;
    top: 1rem;
    z-index: 1;
  }
}
.author-title-dec {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.375rem;
  text-align: center;
  margin-top: 2rem;
}
.author-wrapper {
  margin-top: 1.875rem;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  justify-content: center;
}
.author-item {
  width: 25%;
  margin: 0 0.6rem;
}

.author-dialog {
  .author-dialog-left {
    border-radius: 1.25rem 0 0 1.25rem;
    background: #31ffda;
    width: 15rem;
    height: 30rem;
    display: flex;
    align-items: center;
    padding: 2rem;
    flex-direction: column;

    .author-dialog-left-name {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .author-dialog-img {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      height: 13.5rem;
    }
  }
  .author-dialog-right {
    border-radius: 0 1.25rem 1.25rem 0;
    background-color: #fff;
    width: 35rem;
    height: 30rem;
    display: flex;
    padding: 1.5rem;
  }
}
@media (max-width: 767px) {
  .author-dialog {
    margin: 1rem;
    flex-direction: column;
    .author-dialog-left {
      width: 100%;
      height: 15rem;
      flex-direction: row;
      border-radius: 1.25rem 1.25rem 0 0;
      .author-dialog-left-name {
        margin-left: 1rem;
      }
      .author-dialog-img {
        height: 11rem;
      }
    }
    .author-dialog-right {
      border-radius: 0 0 1.25rem 1.25rem;
      width: 100%;
      height: 22rem;
    }
  }
  .main {
    margin: 0rem;
    margin-top: 1rem;
  }
  .box {
    padding: 1rem;
    max-height: none;
    border: none;
    box-shadow: none;
    background: none;
    flex-wrap: nowrap;
    overflow: hidden;

    .box-border {
      flex-direction: column-reverse;
      flex: 0 0 100%;
      margin-right: 2rem;

      .box-right {
        width: 100%;
        margin: 0;
        height: 30rem;

        .box-r-bg {
          height: 30rem;
        }
      }
      .box-left {
        width: 100%;
        margin-top: 2rem;
      }
    }
  }

  .change-box {
    // display: none;
    top: 13rem;
  }
  .dis-img {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .author-title {
    font-size: 2rem;
    text-align: center;

    .author-title-img {
      left: 0;
      top: 0;
    }
  }
  .author-title-dec {
    width: 100%;
    font-size: 1rem;
  }
  .author-wrapper {
    width: 18rem;
  }
  .change-item-left {
    left: -3rem;
  }
  .change-item-right {
    right: -3rem;
  }
  .author-item {
    min-width: 18rem;
    margin: 0rem;
    padding: 0 1rem;
  }
  .dis-l-btn {
    left: -10px !important;
    z-index: 10;
  }
  .dis-r-btn {
    right: -10px !important;
  }
  .dis-top {
    font-size: 2rem !important;
  }
  .dis-top-img {
    width: 3rem !important;
    height: 3rem !important;
    top: 0rem !important;
    left: -1.3rem !important;
  }
  .author-group-dark {
    display: none !important;
  }
  .author-group {
    background-color: #fff;
    box-shadow: none !important;
  }
  .author-title-img {
    width: 3rem !important;
    height: 3rem !important;
  }
}
</style>
